import planEntryApiService from "../../api/raily/plan-entry/plan-entry-api.service";
import PlanEntryDetailsRequest from "../../api/raily/plan-entry/details/plan-entry-details.request";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import HttpError from "../../utils/http/http.error";
import PlanEntryDetails from "./details/plan-entry-details";
import PlanEntryDetailsError from "./details/plan-entry-details-error";
import PlanEntryDetailsParams from "./details/plan-entry-details-params";
import planEntryDetailsParamsFactory from "./details/plan-entry-details-params.factory";
import PlanEntryDetailsFactory from "./details/plan-entry-details.factory";
import PlanEntryActiveListError from "./active-list/plan-entry-active-list-error";
import planEntryFinishedListFactory from "./finished-list/plan-entry-finished-list.factory";
import PlanEntryActiveListRequest from "../../api/raily/plan-entry/active-list/plan-entry-active-list.request";
import PlanEntryFinishedListRequest from "../../api/raily/plan-entry/finished-list/plan-entry-finished-list.request";
import PlanEntryActiveList from "./active-list/plan-entry-active-list";
import PlanEntryActiveListParams from "./active-list/plan-entry-active-list-params";
import planEntryActiveListParamsFactory from "./active-list/plan-entry-active-list-params.factory";
import planEntryActiveListFactory from "./active-list/plan-entry-active-list.factory";
import PlanEntryFinishedList from "./finished-list/plan-entry-finished-list";
import PlanEntryFinishedListParams from "./finished-list/plan-entry-finished-list-params";
import planEntryFinishedListParamsFactory from "./finished-list/plan-entry-finished-list-params.factory";
import searchRoadRoutingService from "../../utils/search-road-route/search-road-routing.service";
import PlanEntryRoadRoute from "./road-route/plan-entry-road-route";
import PlanEntryRoadRouteParams from "./road-route/plan-entry-road-route-params";
import planEntryRoadRouteParamsFactory from "./road-route/plan-entry-road-route-params.factory";
import planEntryRoadRouteFactory from "./road-route/plan-entry-road-route.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import PlanEntryFinishedListError from "./finished-list/plan-entry-finished-list-error";

const getDetails = async (
  params: PlanEntryDetailsParams,
  abortSignal: AbortSignal,
): Promise<PlanEntryDetails> => {
  const request: PlanEntryDetailsRequest =
    planEntryDetailsParamsFactory.create(params);

  try {
    const response = await planEntryApiService().getPlanEntryDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return PlanEntryDetailsFactory.create(response.data);
  } catch (_error) {
    const error = _error as HttpError | PlanEntryDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getActiveList = async (
  params: PlanEntryActiveListParams,
  abortSignal: AbortSignal,
): Promise<PlanEntryActiveList> => {
  const request: PlanEntryActiveListRequest =
    planEntryActiveListParamsFactory.create(params);

  try {
    const response = await planEntryApiService().getActiveList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return planEntryActiveListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | PlanEntryActiveListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getFinishedList = async (
  params: PlanEntryFinishedListParams,
  abortSignal: AbortSignal,
): Promise<PlanEntryFinishedList> => {
  const request: PlanEntryFinishedListRequest =
    planEntryFinishedListParamsFactory.create(params);

  try {
    const response = await planEntryApiService().getFinishedList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return planEntryFinishedListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | PlanEntryFinishedListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getRoute = async (
  params: PlanEntryRoadRouteParams,
): Promise<PlanEntryRoadRoute[]> => {
  const request = planEntryRoadRouteParamsFactory.create(params);

  try {
    const response = await searchRoadRoutingService.search(request);

    return planEntryRoadRouteFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const planEntryService = {
  getDetails,
  getFinishedList,
  getActiveList,
  getRoute,
};

export default planEntryService;
